function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex';
import EditUsersReportComponent from '@/apps/customer-insigths/components/EditUsersReportComponent';
import FormSomos1ReportComponent from '@/apps/customer-insigths/components/FormSomos1ReportComponent';
import Somos1Service from '@/apps/customer-insigths/services/somos1_service';
import DashboardDictionaryDatatable from '@/apps/customer-insigths/components/DashboardDictionaryDatatable';
import DashboardDictionaryUpload from '@/apps/customer-insigths/components/DashboardDictionaryUpload.vue';
import { TYPE_ELEMENTS, ROLES_LIST, GA_EVENTS } from '@/js/constants';
export default {
  name: 'Somos1ReportsMaintenance',
  components: {
    DashboardDictionaryUpload: DashboardDictionaryUpload,
    EditUsersReportComponent: EditUsersReportComponent,
    FormSomos1ReportComponent: FormSomos1ReportComponent,
    DashboardDictionaryDatatable: DashboardDictionaryDatatable
  },
  data: function data() {
    return {
      DIALOG_MANAGE_USERS: 'DIALOG_MANAGE_USERS',
      DIALOG_CREATE_REPORT: 'DIALOG_CREATE_REPORT',
      DIALOG_UPDATE_REPORT: 'DIALOG_UPDATE_REPORT',
      DIALOG_DELETE_REPORT: 'DIALOG_DELETE_REPORT',
      DIALOG_DICTIONARY: 'DIALOG_DICTIONARY',
      upload_register_button: true,
      keySomos1Reports: 0,
      items: [],
      headers: [{
        value: 'name',
        text: 'Nombre'
      }, {
        value: 'section',
        text: 'Sección'
      }, {
        value: 'region.region',
        text: 'Region'
      }, {
        value: 'description',
        text: 'Descripción'
      }, {
        text: 'Tags',
        value: 'tags',
        width: 'auto'
      }, {
        value: 'maintenance',
        text: 'Maintenance',
        sortable: false
      }, {
        value: 'actions',
        text: ''
      }],
      newUser: '',
      item: null,
      manage_users_title: 'Gestionar Usuarios',
      manage_report_title: 'Editar Reporte',
      manage_dictionary_title: 'Diccionario',
      maintenance_init: false
    };
  },
  created: function created() {
    this.getSomos1Dashboards();
  },
  computed: {
    isInsishtsAdmin: function isInsishtsAdmin() {
      return window.userInfo.userRoles.includes(ROLES_LIST.INSIGHTS_ADMIN);
    },
    isInsishtsServiceManager: function isInsishtsServiceManager() {
      return window.userInfo.userRoles.includes(ROLES_LIST.INSIGHTS_SERVICE_MANAGER);
    }
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('app', ['setShowLoading'])), {}, {
    onAdd: function onAdd() {
      this.$refs[this.DIALOG_CREATE_REPORT].onOpen();
    },
    getSomos1Dashboards: function getSomos1Dashboards() {
      var _this = this;
      var count_true_maintenance = 0;
      this.setShowLoading(true);
      Somos1Service.getSomos1Reports().then(function (response) {
        _this.items = response.data;
        if (_this.isInsishtsServiceManager && !_this.isInsishtsAdmin) {
          _this.items = _this.items.filter(function (x) {
            return x.section == "Somos1";
          });
        }
        console.log('this.items', _this.items);
        _this.keySomos1Reports += 1;
        // calc maintenance
        _this.items.forEach(function (x) {
          if (x.maintenance) {
            count_true_maintenance = count_true_maintenance + 1;
          }
        });
        if (count_true_maintenance === _this.items.length) {
          _this.maintenance_init = true;
        }
      }).finally(function () {
        return _this.setShowLoading(false);
      });
    },
    onOpenDialog: function onOpenDialog(item, modalName) {
      this.item = item;
      if (this.item.name) {
        if (modalName === this.DIALOG_MANAGE_USERS) {
          this.manage_users_title = 'Gestionar Usuarios - ' + this.item.name;
        }
        if (modalName === this.DIALOG_UPDATE_REPORT) {
          this.manage_report_title = 'Editar Reporte - ' + this.item.name;
        }
      }
      this.$refs[modalName].onOpen();
    },
    onAddReport: function onAddReport(report) {
      var _this2 = this;
      this.setShowLoading(true);
      Somos1Service.addSomos1Report({
        report: report
      }).then(function (response) {
        console.log(response);
        _this2.$refs[_this2.DIALOG_CREATE_REPORT].onClose();
        _this2.getSomos1Dashboards();
      }).finally(function () {
        return _this2.setShowLoading(false);
      });
    },
    onUpdateReport: function onUpdateReport(report) {
      var _this3 = this;
      console.log('report');
      console.log(report);
      this.setShowLoading(true);
      var params = {
        data_update: report
      };
      Somos1Service.updateSomos1Report(report.document_id, params).then(function (response) {
        console.log(response);
        _this3.$refs[_this3.DIALOG_UPDATE_REPORT].onClose();
        _this3.getSomos1Dashboards();
      }).finally(function () {
        return _this3.setShowLoading(false);
      });
    },
    onConfirmDelete: function onConfirmDelete(model) {
      var _this4 = this;
      if (model) {
        Somos1Service.deleteSomos1Report(this.item.document_id).then(function (response) {
          _this4.$refs[_this4.DIALOG_DELETE_REPORT].onClose();
          _this4.getSomos1Dashboards();
        });
      } else {
        this.$refs[this.DIALOG_DELETE_REPORT].onClose();
      }
    },
    changeMaintenance: function changeMaintenance() {
      var _this5 = this;
      this.maintenance_init = !this.maintenance_init;
      this.items.forEach(function (x) {
        x.maintenance = _this5.maintenance_init;
        _this5.onUpdateReport(x);
      });
    },
    onAfterDictionaryUpdate: function onAfterDictionaryUpdate() {
      this.$refs[this.DIALOG_DICTIONARY].onClose();
      this.getSomos1Dashboards();
    },
    showUploadBox: function showUploadBox() {
      this.$refs.DashboardDictionaryUpload.register();
    }
  })
};